import "../features/toolbar-items/styles/block-indents.css";
import "../features/toolbar-items/styles/paragraph-indents.css";
import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.util-sticky-editor-toolbar{z-index:calc(var(--layer-context-sticky) + var(--layer-level-2));position:sticky;top:0}.util-normalise-toolbar-position{margin-bottom:-1px}`);